import { SupportedLanguage } from '@foundation/localization';

import { execGet } from '@/services/utils/RequestUtils';

import { TransbankUrlApiResponse } from '../schemas';

export async function getTransbankUrl(
  paymentIntentId: string,
  accessToken: string,
  locale = SupportedLanguage.English,
  telemetryConsent = false,
): Promise<string> {
  const response = await execGet<TransbankUrlApiResponse>(
    `paymentintent/${paymentIntentId}/transbank/url?tc=${telemetryConsent}&locale=${locale}`,
    accessToken,
  );

  return response.redirectUrl;
}
